import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: {
    type: "area"
  },
  title: {
    text: "Temperature Adherence"
  },
  xAxis: {
    categories: ["1750", "1800", "1850", "1900", "1950", "1999", "2050"],
    tickmarkPlacement: "on",
    title: {
      enabled: false
    }
  },
  yAxis: {
    title: {
      text: "Percent"
    }
  },
  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} millions)<br/>',
    split: true
  },
  plotOptions: {
    area: {
      stacking: "percent",
      lineColor: "#ffffff",
      lineWidth: 1,
      marker: {
        lineWidth: 1,
        lineColor: "#ffffff"
      }
    }
  },
  series: []
};
